import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../context/app/appContext';
import { TopBar } from '../common/TopBar';
import { Sidebar } from '../common/Sidebar';
import { HomeAbel } from './HomeAbel';
import { TotalTransactions } from './TotalTransactions';

import { Route, Switch } from 'react-router-dom';
import ActiveUsers from './ActiveUsers'
import InActiveUsers from './InActiveUsers'
import AllUsers from './AllUsers'
import UnassignedUsers from './UnassignedUsers'
import RecentActions from './RecentActions';
import { useOktaAuth } from '@okta/okta-react';
import { TopUpsComponent } from '../home/TopUpsComponent'
import { EnpsComponent } from '../home/EnpsComponent'
import { EnpsDistribution } from '../home/EnpsDistribution'
import ReportComponent from '../home/ReportComponent'
import { Grid } from 'semantic-ui-react'

export const Home = (props) => {
    const appContext = useContext(AppContext);
    const [enps, setEnps] = useState(null)



    useEffect(() => {
        if (!appContext.teams.length) {
            (async function loadTeams() {
                await appContext.loadTeams();
            })();
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (!appContext.employees.length) {
            (async function loadEmployees() {
                await appContext.setEmployees();
            })();
        }
        // eslint-disable-next-line
    }, []);



    return (
        <div id="app">
            <div id="content" style={{ display: 'flex', height: '100vh' }}>
                <span style={{ width: '10vw', height: '100vh' }}>
                    <Sidebar />
                </span>
                <span style={{ width: '90vw', height: '100vh', overflowY: 'scroll' }}>
                    <div style={{ width: '100%', height: '10vh' }}>
                        <TopBar />
                    </div>
                    <div style={{ width: '90vw', height: '91.5vh', display: 'flex', paddingLeft: '2%', flexDirection: 'column', overflowX: 'scroll' }}>
                        <Grid stretched style={{ width: '100%', marginRight: 0, height: '100%', minHeight:800, marginTop: 0, marginBottom: 0, paddingBottom: 0 }}>
                            <Grid.Row stretched style={{ height: 120 }}>
                                <Grid.Column stretched width={'four'}>
                                    <div style={{ width: '100%', backgroundColor: 'white', borderWidth: 1, borderRadius: 8, borderStyle: 'solid', borderColor: 'rgba(223, 224, 235, 1)' }}><AllUsers /></div>
                                </Grid.Column>
                                <Grid.Column stretched width={'four'}>
                                    <div style={{ width: '100%', backgroundColor: 'white', borderWidth: 1, borderRadius: 8, borderStyle: 'solid', borderColor: 'rgba(223, 224, 235, 1)' }}><ActiveUsers /></div>
                                </Grid.Column>
                                <Grid.Column stretched width={'four'}>
                                    <div style={{ width: '100%', backgroundColor: 'white', borderWidth: 1, borderRadius: 8, borderStyle: 'solid', borderColor: 'rgba(223, 224, 235, 1)' }}><InActiveUsers /></div>
                                </Grid.Column>
                                <Grid.Column stretched width={'four'}>
                                    <div style={{ width: '100%', backgroundColor: 'white', borderWidth: 1, borderRadius: 8, borderStyle: 'solid', borderColor: 'rgba(223, 224, 235, 1)' }}><UnassignedUsers /></div>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row stretched style={{ height: 300 }}>
                                <Grid.Column width={8}>
                                    <div className="topuphomepage" style={{ height: 300, overflowY: 'scroll', width: '100%', backgroundColor: 'white', borderWidth: 1, borderRadius: 8, borderStyle: 'solid', borderColor: 'rgba(223, 224, 235, 1)' }}>
                                        <TopUpsComponent />
                                    </div>
                                </Grid.Column>
                                <Grid.Column width={8}>
                                    <div className="topuphomepage" style={{ height: 300, overflowY: 'scroll', width: '100%', backgroundColor: 'white', borderWidth: 1, borderRadius: 8, borderStyle: 'solid', borderColor: 'rgba(223, 224, 235, 1)' }}>
                                        <RecentActions />
                                    </div>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row style={{ height: 320, paddingBottom: 0, marginBottom: 0 }}>
                                <Grid.Column width={8} style={{ width: '100%', }}>
                                    <div style={{ width: '100%', backgroundColor: 'white', height: 320, borderWidth: 1, borderRadius: 8, borderStyle: 'solid', borderColor: 'rgba(223, 224, 235, 1)' }}><ReportComponent /></div>
                                </Grid.Column>
                                <Grid.Column width={8} style={{ width: '100%', paddingRight: 0 }}>
                                    <Grid stretched style={{ width: '100%', paddingRight: 0, marginRight: 0 }}>
                                        <Grid.Row style={{ height: 125, width: '100%' }}>
                                            <Grid.Column width={8} style={{ paddingRight: 20 }}>
                                                <div style={{ height: 125, width: '100%', backgroundColor: 'white', display: 'flex', justifyContent: 'center', borderWidth: 1, borderRadius: 8, borderStyle: 'solid', borderColor: 'rgba(223, 224, 235, 1)' }}><HomeAbel /></div>
                                            </Grid.Column>
                                            <Grid.Column width={8} style={{ paddingLeft: 20 }}>
                                                <div style={{ height: 125, width: '100%', backgroundColor: 'white', display: 'flex', justifyContent: 'center', borderWidth: 1, borderRadius: 8, borderStyle: 'solid', borderColor: 'rgba(223, 224, 235, 1)' }}><TotalTransactions /></div>
                                            </Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row style={{ height: 175 }}>
                                            <Grid.Column width={8} style={{ paddingRight: 20 }}>
                                                <div style={{ height: 160, overflowY: 'hidden', width: '100%', backgroundColor: 'white', borderWidth: 1, borderRadius: 8, borderStyle: 'solid', borderColor: 'rgba(223, 224, 235, 1)' }}>
                                                    <EnpsComponent setEnps={setEnps} style={{ alignSelf: 'center', justifySelf: 'center' }} />
                                                </div>
                                            </Grid.Column>
                                            <Grid.Column width={8} style={{ paddingLeft: 20 }}>
                                                <div style={{ height: 160, overflowY: 'hidden', width: '100%', backgroundColor: 'white', borderWidth: 1, borderRadius: 8, borderStyle: 'solid', borderColor: 'rgba(223, 224, 235, 1)' }}>
                                                    <EnpsDistribution enps={enps} style={{ alignSelf: 'center', justifySelf: 'center' }} />
                                                </div>
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </div>
                </span>
            </div>
        </div>
    )
};
